import React from 'react';
import { Control, FieldPath, FieldValues } from 'react-hook-form';
import Radio, { RadioProps } from './Radio';
import { useFormField } from '../hooks/useFormField';

interface FormRadioProps<T extends FieldValues> extends Omit<RadioProps, 'name' | 'checked' | 'onChange' | 'error'> {
  name: FieldPath<T>;
  control: Control<T>;
  value: string;
}

function FormRadio<T extends FieldValues>({ 
  name, 
  control, 
  value: radioValue,
  ...radioProps 
}: FormRadioProps<T>) {
  const { value, onChange, onBlur, error } = useFormField({ name, control });

  return (
    <Radio
      {...radioProps}
      name={name}
      value={radioValue}
      checked={value === radioValue}
      onChange={(e) => onChange(e.target.value)}
      onBlur={onBlur}
      error={error}
    />
  );
}

export default FormRadio;